<div class="pdf-container">
    <div *ngFor="let page of pages">
        <canvas #pdfCanvas></canvas>
    </div>
</div>
